import styled from 'styled-components';

export const StyledActionScreensWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .payments {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`